import React, {
  ChangeEvent,
  FunctionComponent,
  useState,
  useRef,
  useEffect,
} from 'react';
import { IssueBox } from '../Styles/IssueTool';
import { useTranslation } from 'react-i18next';
import { IReview } from '../../../__core/Interfaces/IReview';
import { get } from 'lodash';
import TextareaAutosize from 'react-textarea-autosize';

type RateToolProps = {
  addReview: (justification: string | null) => void;
  onClose: () => void;
  review: IReview | null;
  grade: number;
};

const RateTool: FunctionComponent<RateToolProps> = ({
  addReview,
  onClose,
  review,
  grade,
}) => {
  const { t } = useTranslation();
  const initMessage = get(review, 'justification', null);
  const requiredJustificationForGradeValue = 2;
  const [message, setMessage] = useState<string | null>(initMessage);
  const [hasError, setHasError] = useState(false);
  const isNewRate = !review;
  const ref = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (event: MouseEvent): void => {
    const current = get(ref, 'current');
    if (current && !current.contains(event.target as Node)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  const onChangeMessage = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    const { value } = event.target;
    setMessage(value);
  };

  const onAddReview = (): void => {
    if (grade <= requiredJustificationForGradeValue && !message) {
      setHasError(true);
    } else {
      setHasError(false);
      addReview(message);
      onClose();
    }
  };

  return (
    <IssueBox className="rate" ref={ref}>
      <div className="tooltip-info">{t('Your opinion')}</div>
      <div className="input-group">
        <TextareaAutosize
          value={message ? message : ''}
          onChange={onChangeMessage}
          placeholder={t('Add comment')}
          name="issueMsg"
        />
        {hasError && grade <= requiredJustificationForGradeValue && (
          <span className="error">{t('Comment has required!')}</span>
        )}
      </div>
      <div className="actions">
        <button className="primary" onClick={onAddReview}>
          {t(isNewRate ? 'Add' : 'Change')}
        </button>
        <button className="secondary" onClick={onClose}>
          {t('Cancel')}
        </button>
      </div>
    </IssueBox>
  );
};

export default RateTool;
